var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.value.isCompletedSuccessfully ? _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("appraisal.response.title")) + " ")]), _c('v-card-text', [_c('v-sheet', {
    staticClass: "pa-4",
    attrs: {
      "rounded": "",
      "color": "grey lighten-4"
    }
  }, [_c('appraisal-sheet', {
    attrs: {
      "appraisal": _vm.value
    }
  })], 1)], 1)], 1) : _c('div', [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("appraisal.response.title")) + " ")]), _c('v-card-subtitle', [_c('span', [_vm._v(" " + _vm._s(_vm.$t("appraisal.response.subtitle")) + " ")]), _vm.value.date ? _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("thg.PriceTable.to", {
    date: _vm.simpleDoubleDigitDate(_vm.value.date)
  })) + " ")]) : _vm._e()], 1), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "info",
      "elevation": 0,
      "disabled": _vm.value.isCompleted
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("appraisal.response.makeOffer")) + " ")])], 1)], 1), _vm.value.history && _vm.value.history.length > 0 ? _c('appraisal-response-card-history', {
    attrs: {
      "value": _vm.value
    }
  }) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "title": _vm.$t('appraisal.response.makeOffer'),
      "subtitle": _vm.$t('appraisal.response.makeOfferSubtitle'),
      "supressKeyboardActions": true,
      "loading": _vm.loading,
      "rightLoading": _vm.loading || _vm.loadingRequestMoreData || _vm.loadingRespondReject,
      "rightDisabled": !_vm.isValid,
      "hideRight": _vm.hideRight,
      "leftText": _vm.leftText,
      "rightText": _vm.rightText,
      "width": 1200
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": _vm.leftClick,
      "rightClick": _vm.rightClick
    }
  }, [_c('v-form', {
    model: {
      value: _vm.isValid,
      callback: function callback($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-window', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.CreateInvoiceWindow.FILE
    }
  }, [_c('v-radio-group', {
    model: {
      value: _vm.response,
      callback: function callback($$v) {
        _vm.response = $$v;
      },
      expression: "response"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": _vm.$t('appraisal.response.makeOffer'),
      "value": _vm.ResponseType.ACCEPT
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('appraisal.response.requestMore'),
      "value": _vm.ResponseType.REQUEST
    }
  }), _c('v-radio', {
    attrs: {
      "label": _vm.$t('appraisal.response.reject'),
      "value": _vm.ResponseType.REJECT
    }
  })], 1), _vm.response === _vm.ResponseType.ACCEPT ? _c('drop-area-multi', {
    staticClass: "my-2",
    attrs: {
      "files": _vm.files,
      "text": _vm.$t('cost.dragAndDropDocuments'),
      "dragoverText": _vm.$t('sign.SignDocumentCreateDialog.title'),
      "loading": _vm.loading,
      "accept": ".pdf",
      "maxFiles": 1
    },
    on: {
      "update:files": function updateFiles($event) {
        _vm.files = $event;
      }
    }
  }) : _vm._e(), _vm.response === _vm.ResponseType.REQUEST ? _c('v-textarea', {
    attrs: {
      "label": _vm.$t('appraisal.response.requestMoreReason'),
      "hint": _vm.$t('appraisal.response.requestMoreReasonHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.requestMoreDataReason,
      callback: function callback($$v) {
        _vm.requestMoreDataReason = $$v;
      },
      expression: "requestMoreDataReason"
    }
  }) : _vm._e(), _vm.response === _vm.ResponseType.REJECT ? _c('v-textarea', {
    attrs: {
      "label": _vm.$t('appraisal.response.rejectReason'),
      "hint": _vm.$t('appraisal.response.rejectReasonHint'),
      "persistent-hint": "",
      "outlined": ""
    },
    model: {
      value: _vm.rejectReason,
      callback: function callback($$v) {
        _vm.rejectReason = $$v;
      },
      expression: "rejectReason"
    }
  }) : _vm._e()], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.CreateInvoiceWindow.FIELDS
    }
  }, [_c('appraisal-form', {
    staticClass: "pt-1",
    attrs: {
      "value": _vm.valueCopy,
      "disabled": _vm.loading
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }